import { useEffect, useState } from "react";
import { ScrollText } from "lucide-react";
import { api } from "@/lib/api";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit-logs", { params: { limit: 100 } }).then((r) => setItems(r.data.items)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-audit-log-page">
      <h1 className="font-display text-2xl font-bold text-piks-black mb-1">Audit Log</h1>
      <p className="text-sm text-piks-muted mb-6">Rekod tindakan pentadbiran sistem.</p>

      {loading ? (
        <p className="text-piks-muted text-sm">Memuatkan...</p>
      ) : items.length === 0 ? (
        <div className="text-center py-16 text-piks-muted bg-white rounded-xl border border-piks-border" data-testid="audit-log-empty-state">
          <ScrollText className="w-10 h-10 mx-auto mb-3 opacity-40" /> Tiada rekod audit.
        </div>
      ) : (
        <>
          <div className="hidden sm:block bg-white rounded-xl border border-piks-border overflow-x-auto">
            <table className="w-full text-sm min-w-[640px]">
              <thead>
                <tr className="border-b border-piks-border text-left text-xs text-piks-muted uppercase tracking-wide">
                  <th className="p-4">Masa</th><th className="p-4">Pelaku</th><th className="p-4">Tindakan</th><th className="p-4">Entiti</th>
                </tr>
              </thead>
              <tbody>
                {items.map((a) => (
                  <tr key={a.id} className="border-b border-piks-border last:border-0" data-testid={`audit-row-${a.id}`}>
                    <td className="p-4 text-piks-muted whitespace-nowrap">{new Date(a.timestamp).toLocaleString("ms-MY")}</td>
                    <td className="p-4 text-piks-black">{a.actor_name}</td>
                    <td className="p-4 font-mono text-xs text-piks-black">{a.action}</td>
                    <td className="p-4 text-piks-muted">{a.entity} {a.entity_id ? `#${a.entity_id.slice(-6)}` : ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="sm:hidden space-y-3">
            {items.map((a) => (
              <div key={a.id} className="p-4 rounded-xl bg-white border border-piks-border" data-testid={`audit-card-${a.id}`}>
                <div className="flex justify-between items-start gap-2 mb-1.5">
                  <span className="font-mono text-xs text-piks-black break-all">{a.action}</span>
                  <span className="text-[11px] text-piks-muted whitespace-nowrap shrink-0">{new Date(a.timestamp).toLocaleString("ms-MY")}</span>
                </div>
                <p className="text-xs text-piks-muted">
                  <span className="text-piks-black font-medium">{a.actor_name}</span> · {a.entity} {a.entity_id ? `#${a.entity_id.slice(-6)}` : ""}
                </p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
